/**
 * Figma Components - Created by Jesus Apodaca on 29/07/2026
 */

import styled from 'styled-components'

interface ButtonProps {
  maxWidth?: string
  disabled?: boolean
}

interface TextLinkProps {
  underline?: boolean
}

interface ColumnDivProps {
  gap?: string
}

export const PrimaryCTA = styled.div<ButtonProps>`
  display: inline-flex;
  height: var(--spacing-42);
  padding: 7px var(--spacing-16);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-12);
  background: var(--neutral-darkest);
  color: var(--neutral-white);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  max-width: ${(props: ButtonProps) => props.maxWidth || 'auto'};
  width: 100%;
  transition: background .25s;
  &:hover {
    cursor: pointer;
    background: var(--neutral-body);
  }
  ${(props: ButtonProps) => props.disabled && `
    pointer-events: none;
    cursor: not-allowed;
    background: var(--neutral-muted);
    &:hover {
      cursor: not-allowed;
      background: var(--neutral-muted);
    }
  `}
  // Dark mode - opposite of default
  &[data-mode="dark"] {
    border: 1px solid var(--neutral-darkest);
    background: var(--neutral-white);
    color: var(--neutral-darkest);
    &:hover {
      background: var(--neutral-border-light);
    }
    ${(props: ButtonProps) => props.disabled && `
      background: var(--neutral-border-light);
    `}
  }
`

export const SecondaryCTA = styled.div<ButtonProps>`
  box-sizing: border-box;
  display: inline-flex;
  height: var(--spacing-42);
  padding: var(--spacing-8) var(--spacing-16);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-8);
  background: var(--neutral-white);
  border: var(--border-regular) solid var(--neutral-muted);
  color: var(--neutral-body);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  max-width: ${(props: ButtonProps) => props.maxWidth || 'auto'};
  width: 100%;
  transition: border .25s, color .25s;
  > svg,
  > img,
  > i,
  > .anticon {
    flex-shrink: 0;
    display: block;
    width: 14px;
    height: 14px;
    object-fit: contain;
    font-size: 14px;
    line-height: 1;
  }
  &:hover {
    cursor: pointer;
    color: var(--neutral-darkest);
    border: var(--border-regular) solid var(--neutral-darkest);
  }
  // Dark mode - opposite of default
  &[data-mode="dark"] {
    border: var(--border-regular) solid var(--neutral-secondary);
    background: var(--neutral-darkest);
    color: var(--neutral-border-light);
    &:hover {
      border: var(--border-regular) solid var(--neutral-white);
      color: var(--neutral-white);
    }
  }
`

export const TextLink = styled.div<TextLinkProps>`
  box-sizing: border-box;
  display: inline-flex;
  height: var(--spacing-24);
  gap: var(--spacing-8);
  align-items: center;
  margin: 0;
  padding: 0;
  color: var(--neutral-secondary);
  font-family: var(--font-inter);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  white-space: nowrap;
  text-decoration-line: ${(props: TextLinkProps) =>
    props.underline === false ? 'none' : 'underline'};
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: 14%;
  text-underline-position: from-font;
  transition: color .25s;
  > svg,
  > img,
  > i,
  > .anticon {
    flex-shrink: 0;
    display: block;
    width: var(--spacing-20);
    height: var(--spacing-20);
    font-size: var(--spacing-20);
    line-height: 1;
    color: inherit;
    fill: currentColor;
    text-decoration: none;
    object-fit: contain;
  }
  &:hover {
    cursor: pointer;
    color: var(--neutral-darkest);
  }
`

export const ColumnDiv = styled.div<ColumnDivProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ gap }: ColumnDivProps) => gap || '0'};
`

export const CountUpRoot = styled.p`
  position: relative;
  display: inline-block;
  margin: 0;
  font-variant-numeric: tabular-nums;
`

export const CountUpSizer = styled.span`
  visibility: hidden;
  display: block;
  white-space: nowrap;
`

export const CountUpValue = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`

/** Shells stay width: 100%; ContentInner constrains and centers content (max 1440). */
export const ContentInner = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: var(--spacing-72);
  @media (max-width: 1279px) {
    padding-inline: var(--spacing-24);
  }
  @media (max-width: 767px) {
    padding-inline: var(--spacing-16);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/theme/components.tsx